import styled from 'styled-components/macro'

import { ImageContainer, Img } from 'components/parallax/styled'
import { mq } from 'styles/mq'

export const ImgContainer = styled(ImageContainer)`
  ${mq.parallaxOn} {
    padding-inline: var(--spacing-sm);
  }
`

export const Image = styled(Img)`
  margin: 0 auto;
`
